/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {FeatureStateDependencies} from './feature-state-dependencies';

export interface AdnRouterStateHelper {
  listPath: () => string;
  list: (extras?: any, objectType?: string, crumbParams?: any) => any;
  newPath: (pathState: string) => string;
  newItemPath: () => string;
  newItem: (extras?: any) => any;
  itemPath: () => string;
  item: (extras?: any, objectType?: string) => any;
}

export type AdnRouterHelperApi = {
  services: FeatureStateDependencies;
  createRouterHelper: (
    states: string,
    resourceProvider: any,
    parent: string,
    dir: string,
    listTemplate?: string | null
  ) => AdnRouterStateHelper;
  createRouterAndChildHelper: (
    states: string,
    resourceProvider: any,
    childProvider: any,
    parent: string,
    dir: string,
    listTemplate?: string | null
  ) => AdnRouterStateHelper;
};

export class StateDeclarationBuilder {
  private readonly declarations: Ng2StateDeclaration[] = [];

  add(name: string | Ng2StateDeclaration, config?: any): this {
    this.declarations.push(typeof name === 'string' ? {name, ...config} : name);
    return this;
  }

  build(): Ng2StateDeclaration[] {
    return this.declarations;
  }
}
